import React from "react";
import ReactDOM from "react-dom";
import "./styles/css/index.css";
import "./styles/css/react-notifications.css";
import "react-notifications/lib/notifications.css";
import App from "./App";

import { Provider } from "react-redux";
import { store } from "./redux/store";
import {
	enableFourDigitYearDateInputs,
	enableDraggableDialogs,
	enableTrimmedTextInputs,
} from "./common-utilities/globalUiBehaviors";

import LogRocket from "logrocket";
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
	// dev code
} else {
	LogRocket.init("ghozmy/vlp-react");
}

enableFourDigitYearDateInputs();
enableDraggableDialogs();
enableTrimmedTextInputs();

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
);
